import './renderer.css';
import Markdown from 'marked-react';


export default function Renderer({content}){    

    return (
        <Markdown>{content}</Markdown>
    )
}